





























































































































import { Component, Vue, Prop, PropSync } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { required, decimal, minValue, maxValue } from 'vuelidate/lib/validators';
import { EntityLocationsApi, EntityLocation, Transceiver, ProductsApi } from '@/api';
import Toast from '@/components/display/toast.vue';
import siteIconUrl from '@/assets/mapIcons/siteIcon.png';
import sensorIconUrl from '@/assets/mapIcons/sensorIcon.png';
import nodeIconUrl from '@/assets/mapIcons/nodeIcon.png';
import gatewayIconUrl from '@/assets/mapIcons/gatewayIcon.png';
import transceiverIconUrl from '@/assets/mapIcons/transceiverIcon.png';
import { Validations } from 'vuelidate-property-decorators';
import { mixins } from 'vue-class-component';

@Component({
	components: { Toast },
})
export default class AddUpdateEntityLocation extends mixins(validationMixin) {
	private emailRequired = true;
	private billingRequired = true;
	private loading = false;

	@Prop() private entityLocationData: EntityLocation;
	@Prop(Array) private parentLocations: Object[];
	private latLng = '';
	private submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	private entityData: any = null;
	private center = L.latLng(0, 0);
	private zoom = 15;
	private APIKey = 'd01fbtg0ar02se9fxybaqv0jxhw';

	private tileProviders = [
		{
			name: 'ESRI',
			visible: true,

			url:
				'https://ibasemaps-api.arcgis.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}?token=secret',
			attribution:
				'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
		},
		{
			name: 'Open Street Map',
			visible: false,

			url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
			attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
		},
		{
			name: 'LINZ Topo 50',
			visible: false,

			url:
				'https://basemaps.linz.govt.nz/v1/tiles/aerial/EPSG:3857/{z}/{x}/{y}.webp?api=' +
				this.APIKey,
			attribution: '<a href=“http://data.linz.govt.nz”>Sourced from LINZ. CC BY 4.0</a>',
		},
	];

	// 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
	private hardwareIcon = L.Icon.extend({
		options: {
			iconSize: [31, 46], // size of the icon
			shadowSize: [31, 46], // size of the shadow
			iconAnchor: [15, 23],
			popupAnchor: [0, -23], // point from which the popup should open relative to the iconAnchor
		},
	});
	private sensorIcon = new this.hardwareIcon({ iconUrl: sensorIconUrl });
	private nodeIcon = new this.hardwareIcon({ iconUrl: nodeIconUrl });
	private gatewayIcon = new this.hardwareIcon({ iconUrl: gatewayIconUrl });
	private transceiverIcon = new this.hardwareIcon({ iconUrl: transceiverIconUrl });

	private center = L.latLng(0, 0);

	private isValid(field) {
		return field && field.$dirty ? !field.$invalid : null;
	}

	private stepValidate() {
		const form = this.$v.latLng;
		form.$touch();
		console.log(this.latLng);
		if (!form.$invalid) {
			this.onComplete();
		}
	}

	constructor() {
		super();
	}

	private markerLocation(e: Event) {
		this.setLocation(e.target._latlng.lat, e.target._latlng.lng);
	}

	private locationRegexMatch(value: any) {
		if (value) {
			console.log(value);
			let regex = new RegExp(
				'^[-+]?([1-8]?\\d(\\.\\d+)?|90(\\.0+)?),\\s*[-+]?(180(\\.0+)?|((1[0-7]\\d)|([1-9]?\\d))(\\.\\d+)?)$',
				'g',
			);
			return regex.test(value);
		} else {
			return false;
		}
	}

	public mounted() {
		if (this.entityLocationData.latitude && this.entityLocationData.longitude) {
			this.center = L.latLng(this.entityLocationData.latitude, this.entityLocationData.longitude);
			this.setLatLng(this.entityLocationData.latitude!, this.entityLocationData.longitude!);
		} else if (this.parentLocations[0]?.latitude && this.parentLocations[0]?.longitude) {
			this.center = L.latLng(this.parentLocations[0].latitude, this.parentLocations[0].longitude);
			this.setLatLng(this.parentLocations[0].latitude!, this.parentLocations[0].longitude!);
		} else {
			this.center = L.latLng(0, 0);
			this.setLatLng(0, 0);
		}
	}

	private setLatLng(latitude: number | string, longitude: number | string) {
		this.latLng = `${latitude}, ${longitude}`;
	}

	@Validations()
	private validations() {
		return {
			latLng: { regex: this.locationRegexMatch },
		};
	}

	get markerIcon() {
		switch (this.entityLocationData.entityType) {
			case 'transceivers':
				return this.transceiverIcon;
			case 'sensors':
				return this.sensorIcon;
			case 'nodes':
				return this.nodeIcon;
			case 'gateways':
				return this.gatewayIcon;
			// case 'site':
			//   return this.siteIcon;
			default:
				console.log(`Entity Type not found Icon not set.`);
				return this.gatewayIcon;
		}
	}

	public setLocation(latitude: number, longitude: number) {
		if (latitude && longitude) {
			this.setLatLng(latitude, longitude);
			this.center = L.latLng(latitude, longitude);
		} else {
			navigator.geolocation.getCurrentPosition(
				position => {
					this.setLatLng(+position.coords.latitude || 0, +position.coords.longitude || 0);
					this.center = L.latLng(+position.coords.latitude || 0, +position.coords.longitude || 0);
				},
				err => {
					console.log('Failed to get your current location:', err);
					new Toast().makeToast(
						'Failed to get your current location: {reason: err.message || err n}',
						'Geo - Location Error',
						'danger',
						true,
					);
				},
			);
		}

		const locationValidator = this.$v;
		if (locationValidator) {
			locationValidator.$touch();
		}
	}

	public async onComplete() {
		this.submitStatus = 'PENDING';
		try {
			let {
				['id']: remove,
				['latitude']: removeLatitude,
				['longitude']: removeLongitude,
				...data
			} = this.entityLocationData;
			if (this.entityLocationData.id) {
				await new EntityLocationsApi().updateEntityLocation(this.entityLocationData.id, {
					data: {
						latitude: parseFloat(this.latLng.split(',')[0]),
						longitude: parseFloat(this.latLng.split(',')[1]),
						...data,
					},
				});
			} else {
				await new EntityLocationsApi().createEntityLocation({
					data: {
						latitude: parseFloat(this.latLng.split(',')[0]),
						longitude: parseFloat(this.latLng.split(',')[1]),
						...data,
					},
				});
			}
		} catch (e) {
			let error;
			if (e.response) {
				if (e.response.data.message) {
					error = 'Entity Location not updated ' + e.response.data.message;
				} else {
					error = 'Entity Location not updated unknown error, check response';
				}
			} else if (e.request) {
				error = 'Entity Location not updated, network Error';
			} else {
				error = 'Entity Location not updated, unknown Error';
			}
			// const error = e.response.data.errors.name[0];
			new Toast().makeToast(error, 'Error updating Entity Location', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}

		this.setLatLng(0, 0);

		this.$v.$reset();
		this.submitStatus = 'OK';
		this.$emit('load');
	}
	private cancel() {
		this.setLatLng(0, 0);

		this.$v.$reset();
		this.$bvModal.hide(
			`Edit${this.entityLocationData.entityType}${this.entityLocationData.entityId}`,
		);

		this.$emit('load');
	}

	private modalShown() {
		setTimeout(() => {
			//mapObject is a property that is part of leaflet
			this.$refs[
				`update${this.entityLocationData.entityType}${this.entityLocationData.entityId}EntityLocation`
			].mapObject.invalidateSize();
		}, 100);
	}
	private zoomUpdated(zoom) {
		this.zoom = zoom;
	}
	private centerUpdated(center) {
		this.center = center;
	}
}
